import React, { useEffect, useState } from "react";
import { useMapsLibrary, MapControl, useMap } from "@vis.gl/react-google-maps";

const PlaceAutocomplete = ({ onPlaceSelect, address }) => {
  const map = useMap();
  const places = useMapsLibrary("places");
  const inputRef = React.useRef(null);
  // const [autocomplete, setAutocomplete] = useState(null);

  useEffect(() => {
    if (!places || !window.google || !window.google.maps || !inputRef.current)
      return;

    const options = {
      fields: ["geometry", "formatted_address"],
    };

    const autoComplete = new places.Autocomplete(inputRef.current, options);

    autoComplete.addListener("place_changed", () => {
      const place = autoComplete.getPlace();
      if (place.geometry && place.geometry.location) {
        map.panTo({
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          })
        onPlaceSelect({
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
        place.formatted_address);
      }
    });

    // setAutocomplete(autoComplete);

    return () => {
      if (autoComplete) {
        window.google.maps.event.clearInstanceListeners(autoComplete);
      }
    };
  }, [places, onPlaceSelect, map]);

  if (!window.google || !window.google.maps) return null;

  return (
    <>
      <label
        htmlFor="location"
        className="block text-sm/6 font-medium text-gray-900"
      >
        Business location
      </label>
      <MapControl position={2}>
        <input
          id="location"
          ref={inputRef}
          defaultValue={address}
          type="text"
          placeholder="Search address..."
          className="block w-[300px] h-[40px] rounded-md mt-10 border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
        />
      </MapControl>
    </>
  );
};

export default PlaceAutocomplete;
